// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-15T18:32:55.209Z
// Property: The Fairways at Edinburgh (ID: 6767906449167161)
// Collections: 32 amenities, 12 floorplans (live), 24 photos, 40 POIs, 4 reviews, 15 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167161",
  "property_external_id": "745548",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-fairways-at-edinburgh-brooklyn-park-mn/4cv1bkk/",
  "property_google_business_url": "https://www.google.com/maps/place/Fairways+at+Edinburgh/data=!4m2!3m1!1s0x0:0x53f9af96f017193c?sa=X&ved=2ahUKEwjb5If834OTAxW0qpUCHThYC_kQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-fairways-at-edinburgh",
  "property_name": "The Fairways at Edinburgh",
  "property_website_url": "www.homeisfairways.com",
  "property_domain": "https://www.homeisfairways.com",
  "property_address": "8617 Edinbrook Crossing",
  "property_full_address": "8617 Edinbrook Crossing, Minneapolis, MN, 55443",
  "property_address_1": "8617 Edinbrook Crossing",
  "property_address_2": null,
  "property_address_city": "Minneapolis",
  "property_address_state": "MN",
  "property_address_zip_full": null,
  "property_address_zip": "55443",
  "property_address_country": "US",
  "property_address_county": "Hennepin County",
  "property_neighborhood_address": "Brooklyn Park",
  "property_address_latitude": "45.1114",
  "property_address_longitude": "-93.3297",
  "property_email": "fairways@weidner.com",
  "property_phone": "7633632153",
  "property_call_tracking_phone": "763-244-3529",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Fairways in Brooklyn Park, MN, where comfort meets convenience. Choose from diverse floor plans—studio to three-bedroom—and enjoy a wealth of amenities like a refreshing pool, lush courtyards, and pet-friendly spaces. Find your new home today by browsing our availability or scheduling a tour!",
  "property_long_description": "Welcome to The Fairways, your ideal apartment community nestled in the heart of Brooklyn Park, MN. Discover a diverse selection of floor plans to suit your lifestyle, including cozy studios, spacious one-bedroom, and family-friendly two and three-bedroom options. Whether you're a busy professional or a family looking for more space, we have the perfect home for you!\n\nAt The Fairways, we prioritize your comfort and enjoyment with a range of exceptional amenities. Dive into relaxation at our inviting pool, complete with a luxurious poolside lounge deck perfect for soaking up the sun. Our reservable community room is ideal for gatherings, while our lush courtyards provide a serene escape for quiet moments outdoors. Plus, enjoy the convenience of free on-site parking and in-unit laundry for your everyday ease.\n\nWe love our furry friends! The Fairways is a pet-friendly community, welcoming your pets to join in on the fun. Each apartment features a private balcony, allowing you to unwind and take in the beautiful surroundings right from your home.\n\nExperience the perfect combination of comfort, convenience, and community at The Fairways. Don't just take our word for it—find your new home today! Browse our availability or schedule a tour to explore all that The Fairways has to offer. Your new life awaits in Brooklyn Park!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d08c2-78b6-724b-a601-2ef689559c3b.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool area with lounge chairs and seating.",
    "public_id": "019d08c2-78b6-724b-a601-2ef689559c3b",
    "storage_key": "property/6767906449167161/019d08c2-78b6-724b-a601-2ef689559c3b.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "198",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.44444444444444",
  "property_admin_fee": "175",
  "property_application_fee": "50",
  "property_fees_deposit_info": "350-500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome. Pet deposit: $300. Pet fee: $300. Monthly pet rent: $40 per pet. Maximum number of pets: 2 per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://homeisfairways.securecafe.com/onlineleasing/the-fairways-at-edinburgh/floorplans.aspx",
  "property_resident_portal_url": "https://homeisfairways.securecafenet.com/residentservices/the-fairways-at-edinburgh/userlogin",
  "property_apply_now_url": "https://homeisfairways.securecafe.com/onlineleasing/the-fairways-at-edinburgh/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d08c2-8475-71af-973b-916172bc31a7.webp",
  "property_primary_logo_media": {
    "alt_text": "The Fairways Apartments at Edinburgh logo",
    "public_id": "019d08c2-8475-71af-973b-916172bc31a7",
    "storage_key": "property/6767906449167161/019d08c2-8475-71af-973b-916172bc31a7.webp",
    "width": 347,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d08c2-8f3c-73c9-9593-a303a5b0d6a3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Fairways Apartments at Edinburgh logo",
    "public_id": "019d08c2-8f3c-73c9-9593-a303a5b0d6a3",
    "storage_key": "property/6767906449167161/019d08c2-8f3c-73c9-9593-a303a5b0d6a3.webp",
    "width": 347,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d08c2-98a0-71aa-8fbd-36c796460008.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Fairways Apartments at Edinburgh logo.",
    "public_id": "019d08c2-98a0-71aa-8fbd-36c796460008",
    "storage_key": "property/6767906449167161/019d08c2-98a0-71aa-8fbd-36c796460008.webp",
    "width": 347,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#111418",
  "property_secondary_color": "#b5cde7",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#374354",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1590",
  "property_sqft_min": "469",
  "property_sqft_max": "1590",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 33,
  "property_facebook_url": "https://www.facebook.com/TheFairwaysAtEdinburghApartments",
  "property_instagram_url": "https://www.instagram.com/fairwaysatedinburghapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJqVxsR3A6s1IRPBkX8Jav-VM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartments",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Fairways",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to The Fairways in Brooklyn Park, MN, where comfort meets style. Revel in our inviting poolside lounge, lush courtyards, and pet-friendly atmosphere. With in-unit laundry, private balconies, and a reservable community room, your ideal lifestyle awaits. Embrace a vibrant community that feels like home. ",
  "property_home_floorplans_blurb": "Welcome to The Fairways in Brooklyn Park, MN, where modern living meets comfort. Our thoughtfully designed floor plans cater to your lifestyle, offering the perfect backdrop for your next chapter. Browse our available apartment homes today and let the journey to your ideal living space begin!",
  "property_home_gallery_blurb": "Welcome to The Fairways in Brooklyn Park, MN, where modern living meets serene leisure. Enjoy sunny afternoons by the pool, unwind on your private balcony, or gather with friends in our community room. With lush courtyards and pet-friendly amenities, you'll find your perfect home here—imagine your life at The Fairways!",
  "property_home_neighborhood_blurb": "At The Fairways in Brooklyn Park, your home is surrounded by an exciting mix of adventure and recreation. Enjoy nearby outdoor escapes like Elm Creek Park Reserve and the Mississippi Gateway Regional Park. Unwind at Slick City Action Park or tee off at Edinburgh Golf Course—all just moments from your front door!",
  "property_home_reviews_blurb": "At The Fairways in Brooklyn Park, MN, residents rave about the “welcoming atmosphere and friendly neighbors.” Experience the warmth of our vibrant community, where comfort meets convenience. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At The Fairways in Brooklyn Park, adventure awaits just steps from your front door. Embrace the outdoors at Elm Creek Park Reserve or unwind at the New Hope Aquatic Park. With top-notch amenities and educational institutions nearby, find the perfect balance of leisure and learning in your vibrant neighborhood.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Fairways in Brooklyn Park, MN, indulge in spacious floor plans from studios to three bedrooms. Bask in sunny courtyards, unwind by the sparkling pool, or enjoy your private balcony. With pet-friendly options and in-unit laundry, your perfect home awaits—complete with a reservable community room for gatherings.",
  "property_applynow_blurb": "Welcome to The Fairways in Brooklyn Park, MN, where modern living meets comfort. Choose from our diverse floor plans—studios to three-bedrooms. Enjoy sun-soaked days at the pool, vibrant courtyards, and a pet-friendly environment. Ready to elevate your lifestyle? Secure your new home and lease online today!",
  "property_contactus_blurb": "At The Fairways in Brooklyn Park, MN, we offer a variety of unique floor plans, including cozy studios and spacious three-bedroom apartments. Each layout is designed to suit your lifestyle perfectly. Have questions? Our leasing team is ready to assist you—reach out today!",
  "property_faqs_blurb": "At The Fairways in Brooklyn Park, MN, we understand that choosing the right home is essential. From cozy studios to spacious three-bedroom layouts, our apartments cater to every lifestyle. Curious about our community? Browse our FAQs page for insights into living your best life with us!",
  "property_floorplans_blurb": "At The Fairways in Brooklyn Park, MN, you'll find a unique blend of comfort and style in our diverse floor plans. From cozy studios to spacious three-bedroom layouts, we offer options that cater to your lifestyle. Browse our available apartment homes to uncover your ideal living space today!",
  "property_gallery_blurb": "At The Fairways in Brooklyn Park, MN, your ideal home awaits! Choose from stylish studio to spacious three-bedroom layouts. Enjoy lush courtyards, a sparkling pool, and inviting private balconies. With pet-friendly amenities and convenient in-unit laundry, this is more than just an apartment—it's your sanctuary. Picture yourself living here!",
  "property_interactivemap_blurb": "At The Fairways in Brooklyn Park, MN, comfort meets convenience. Choose from stylish studio to spacious three-bedroom apartments, complete with private balconies and in-unit laundry. Enjoy sun-filled days by our sparkling pool, unwind in lush courtyards, or reserve our community room for gatherings. Your perfect home awaits—explore our interactive map today!",
  "property_pets_blurb": "At The Fairways in Brooklyn Park, MN, your furry friends are part of the family! Indulge in spacious living with room to roam, featuring a welcoming pet policy that allows two pets per unit. Enjoy the lush surroundings and take leisurely strolls with your dogs right at your doorstep.",
  "property_referafriend_blurb": "At The Fairways in Brooklyn Park, MN, your perfect home awaits! With versatile floor plans ranging from cozy studios to spacious three-bedrooms, there's a place for everyone. Great friends make great neighbors—refer a friend today and enhance your community experience! Your new chapter begins here!",
  "property_residentaccess_blurb": "At The Fairways in Brooklyn Park, MN, our diverse floor plans—from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Access your resident portal easily to manage payments, schedule maintenance, and connect with community updates. Experience seamless living at The Fairways today!",
  "property_reviews_blurb": "At The Fairways in Brooklyn Park, MN, residents rave about their vibrant community, highlighting how \"the friendly atmosphere truly feels like home.\" Don’t just take our word for it—see what our residents have to say about living at our community and experience the difference for yourself!",
  "property_created_at": "1771532295340",
  "property_scheduletour_blurb": "At The Fairways in Brooklyn Park, MN, you’ll find a perfect blend of comfort and style in our versatile floor plans, including studio, one, two, and three-bedroom options. Curious about community life? Schedule a tour and hear firsthand from our residents why they love calling The Fairways home!",
  "property_thankyou_blurb": "Thank you for reaching out to The Fairways in Brooklyn Park, MN! We're excited to help you find the perfect home, whether it's a cozy studio or a spacious three-bedroom apartment. Our diverse floor plans cater to every lifestyle. Keep an eye on your inbox; our team will be in touch soon!",
  "property_virtualtours_blurb": "Experience the charm of The Fairways in Brooklyn Park, MN, where our thoughtfully designed studio, one, two, and three-bedroom apartments cater to every lifestyle. Immerse yourself in our vibrant community with a virtual tour that showcases the perfect blend of comfort and convenience waiting just for you!",
  "property_copyright": "2026 All Rights Reserved. The Fairways",
  "property_seo_title_home": "The Fairways |  Apartments in Brooklyn Park, MN",
  "property_seo_description_home": "Experience modern living at The Fairways in Brooklyn Park, MN. Choose from studio to three-bedroom apartments with luxe amenities. Claim your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Brooklyn Park, MN Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at The Fairways in Brooklyn Park, MN. Choose from stylish studio to spacious three-bedroom floor plans. Your next adventure awaits!",
  "property_seo_title_amenities": "Amenities | Brooklyn Park, MN Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Fairways in Brooklyn Park, MN. Enjoy stunning amenities like a pool, lounging courtyards, and pet-friendly homes with in-unit laundry. Join us!",
  "property_seo_title_gallery": "Gallery | Apartments in Brooklyn Park, MN",
  "property_seo_description_gallery": "Capture the essence of life at The Fairways in Brooklyn Park, MN. Picture your future home with stunning views, luxury amenities, and pet-friendly living!",
  "property_seo_title_virtualtours": "Virtual Tours | The Fairways Apartments",
  "property_seo_description_virtualtours": "Explore The Fairways in Brooklyn Park! Discover stunning studios to three-bedroom apartments with a virtual tour—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Fairways Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Fairways in Brooklyn Park, MN! Choose from studios to three-bedrooms in a pet-friendly, vibrant community!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Brooklyn Park, MN",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding The Fairways in Brooklyn Park, MN! Dive into local favorites and hidden gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | The Fairways",
  "property_seo_description_contact": "Connect with The Fairways in Brooklyn Park, MN! Whether you need info on our studios or three-bedroom apartments, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Brooklyn Park, MN",
  "property_seo_description_faqs": "Unravel the answers to your questions at The Fairways in Brooklyn Park, MN. From pet-friendly perks to poolside relaxation, your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Brooklyn Park, MN",
  "property_seo_description_reviews": "Join our vibrant community at The Fairways in Brooklyn Park, MN. Hear from residents about poolside relaxation, pet-friendly living, and spacious apartments!",
  "property_seo_title_applynow": "Apply Now | Apartments in Brooklyn Park, MN",
  "property_seo_description_applynow": "Unlock the ideal lifestyle at The Fairways in Brooklyn Park, MN. From pet-friendly living to serene courtyards, your perfect home awaits—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Fairways",
  "property_seo_description_residentaccess": "Welcome to The Fairways resident portal! Seamlessly pay rent, schedule maintenance, and manage your community lifestyle—all from one convenient location!",
  "property_seo_title_referafriend": "Refer A Friend | The Fairways",
  "property_seo_description_referafriend": "Refer a friend to The Fairways in Brooklyn Park, MN! When friends join our community, everyone wins. Great friends make for great neighbors—share the love!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Fairways",
  "property_seo_description_scheduletour": "Experience life at The Fairways in Brooklyn Park, MN—where comfort meets community. Schedule your tour today and envision your new home!",
  "property_seo_title_privacy": "Privacy Policy | The Fairways",
  "property_seo_description_privacy": "At The Fairways in Brooklyn Park, MN, your privacy matters. Learn how we protect your information with our comprehensive privacy policy. View it now!",
  "property_seo_title_accessibility": "Website Accessibility | The Fairways",
  "property_seo_description_accessibility": "At The Fairways in Brooklyn Park, MN, we champion accessibility for all. Join our inclusive community where everyone can thrive and feel at home!",
  "property_seo_title_sitemap": "Sitemap | The Fairways",
  "property_seo_description_sitemap": "Uncover your ideal home at The Fairways in Brooklyn Park, MN! Navigate through our sitemap to find amenities, floor plans, and more with ease.",
  "property_seo_title_thankyou": "Thank You | The Fairways",
  "property_seo_description_thankyou": "Thank you for reaching out to The Fairways! A team member will connect soon to help you find your perfect Brooklyn Park home. Stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Brooklyn Park, MN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787767598272",
  "amenities": [
    {
      "id": "ec_b08b1a0c19179e19158082a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "86771181",
      "title": "24/7 Resident Lounge with WI-FI",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ac2e3aeeeaeed356a27bc91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873393",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_391174fca0a0a932a5539730",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873397",
      "title": "On-site Maintenance & Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0b65494ad21a62e516efe6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873403",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15de7b7ae01a7ee2a147a026",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873413",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b8437578e65979ab96dfc98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873429",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04469eb8828ec1bf9a5366a3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873558",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1936cc431ae328edd1dc5394",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873433",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d9a41-109d-71ce-a16b-80d396488f2e.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills, ellipticals, and stationary bikes in a well-lit fitness center with mirrors and a large TV.",
        "public_id": "019d9a41-109d-71ce-a16b-80d396488f2e",
        "storage_key": "property/6767906449167161/019d9a41-109d-71ce-a16b-80d396488f2e.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15fbbe9b1d842c9da70dd5b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85912258",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_057d7f7001b12925a7cb502b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873415",
      "title": "Reservable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92586d1ad995baacaca5755f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873419",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-322c-73c7-80cf-e438c1155f9f.webp",
      "amenity_image_media": {
        "alt_text": "Kitchenette area with coffee maker, microwave, and sink.",
        "public_id": "019d021a-322c-73c7-80cf-e438c1155f9f",
        "storage_key": "property/6767906449167161/019d021a-322c-73c7-80cf-e438c1155f9f.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bc5628ead99a2222491f75e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873423",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a58712496e5079d6251744e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873425",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b95f75bae344c62f55d4e6ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873561",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df3931266a02346e0350a9a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "124800191",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce28cd45cb090fa60ea5d39d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873436",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d829b360a7f884683a9a269",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873435",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a43d00c1c687cee61370fb80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873437",
      "title": "Book Nook (Reading Area)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a3a4ed0ffd239b9bd1721c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873392",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_347a4f3ba3a73013d1a9950d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873398",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eab83aa3438f32a9eac98a55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873412",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d9a41-149d-7298-9cbf-0fabda1b89e1.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and windows",
        "public_id": "019d9a41-149d-7298-9cbf-0fabda1b89e1",
        "storage_key": "property/6767906449167161/019d9a41-149d-7298-9cbf-0fabda1b89e1.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebadaad667c9729eb1a3d03c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873414",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8048f6064de2769b464c704b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873420",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cedbb790fe67eeb3d0a44dbe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873400",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1f33d3a57545a79e73a576e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873404",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-b081-73b8-ab79-e1613e2f0a01.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019d0219-b081-73b8-ab79-e1613e2f0a01",
        "storage_key": "property/6767906449167161/019d0219-b081-73b8-ab79-e1613e2f0a01.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Fairways Kitchen View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98cca2009ee66b69a1e72bf9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873408",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1ef1a742cd8221d23048584",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873416",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13638d3311d0092b0e0bce3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873580",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45f5a88ee14496557fa76911",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873581",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1b441628b0701e9db7679c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873424",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b162b067c0bfca88b1cfbf72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "86633312",
      "title": "Underground Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12570f76d0fd6635d4193ea8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "yardi",
      "external_id": "85873430",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-cfd1-7152-9bf2-abf2aed90073.webp",
      "amenity_image_media": {
        "alt_text": "Empty bedroom with a closet and two doors.",
        "public_id": "019d0219-cfd1-7152-9bf2-abf2aed90073",
        "storage_key": "property/6767906449167161/019d0219-cfd1-7152-9bf2-abf2aed90073.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_68cc1bec6bf761433bc008f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-a5c8-772d-a0d1-c2ee321def7c.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, large windows, and a door leading outside.",
        "public_id": "019d0219-a5c8-772d-a0d1-c2ee321def7c",
        "storage_key": "property/6767906449167161/019d0219-a5c8-772d-a0d1-c2ee321def7c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a stylish coffee table, and large windows that let in plenty of natural light. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with sectional sofa, coffee table, large windows, and a door leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (1).jpg"
    },
    {
      "id": "ec_a949d8cc085b49cf63673289",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-a5e2-771c-b260-1b078643bd38.webp",
      "image_media": {
        "alt_text": "Dining area and living room with modern furniture, including a glass-top table with chairs and a sofa by the window.",
        "public_id": "019d0219-a5e2-771c-b260-1b078643bd38",
        "storage_key": "property/6767906449167161/019d0219-a5e2-771c-b260-1b078643bd38.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Elegant dining area adjacent to a cozy living space, featuring stylish seating and large windows. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Dining area and living room with modern furniture, including a glass-top table with chairs and a sofa by the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (2).jpg"
    },
    {
      "id": "ec_083ddddafc4d680bedecbae5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-a5e3-7498-9432-e85698f927aa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island, view into bedroom.",
        "public_id": "019d0219-a5e3-7498-9432-e85698f927aa",
        "storage_key": "property/6767906449167161/019d0219-a5e3-7498-9432-e85698f927aa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a large island. Opens to a comfortable bedroom area.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and island, view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (3).jpg"
    },
    {
      "id": "ec_3b8a66dd7cf52c05ca37acd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-b081-73b8-ab79-e1613e2f0a01.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019d0219-b081-73b8-ab79-e1613e2f0a01",
        "storage_key": "property/6767906449167161/019d0219-b081-73b8-ab79-e1613e2f0a01.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, and modern stainless steel appliances. An inviting island with decorative pieces adds a touch of elegance. Opens to a glimpse of a bedroom.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (4).jpg"
    },
    {
      "id": "ec_d4d80cf015674d5903835607",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-b450-749a-8f78-baad8eade196.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, view of bedroom beyond.",
        "public_id": "019d0219-b450-749a-8f78-baad8eade196",
        "storage_key": "property/6767906449167161/019d0219-b450-749a-8f78-baad8eade196.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space. A peek into the cozy bedroom adds to the charm.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, view of bedroom beyond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (5).jpg"
    },
    {
      "id": "ec_eb9afc2ccbf764d0d71ea17f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-b453-7228-a591-9b1fd1a15444.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, desk, and decorative elements.",
        "public_id": "019d0219-b453-7228-a591-9b1fd1a15444",
        "storage_key": "property/6767906449167161/019d0219-b453-7228-a591-9b1fd1a15444.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish and comfortable bedroom featuring a queen-size bed with decorative pillows, elegant nightstands with lamps, and a modern desk with a floral arrangement.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, desk, and decorative elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (6).jpg"
    },
    {
      "id": "ec_240591ebedf75b5bddbc7120",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-b447-706a-a904-123c011f57fd.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and a window.",
        "public_id": "019d0219-b447-706a-a904-123c011f57fd",
        "storage_key": "property/6767906449167161/019d0219-b447-706a-a904-123c011f57fd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a modern nightstand with a lamp, and a white dresser. Natural light streams in through the window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (7).jpg"
    },
    {
      "id": "ec_1da12868c4b843d7d0914d99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-be98-739b-a7e8-bbb19098bdb7.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, toilet, and shower/tub.",
        "public_id": "019d0219-be98-739b-a7e8-bbb19098bdb7",
        "storage_key": "property/6767906449167161/019d0219-be98-739b-a7e8-bbb19098bdb7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with a granite countertop, a comfortable toilet, and a white bathtub with a shower.",
      "link": "false",
      "alt_text": "Bathroom with sink, toilet, and shower/tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (8).jpg"
    },
    {
      "id": "ec_1868378f5100af4ef5122265",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-c080-7542-9c04-1b89313ed379.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, toilet, and shower with patterned curtain.",
        "public_id": "019d0219-c080-7542-9c04-1b89313ed379",
        "storage_key": "property/6767906449167161/019d0219-c080-7542-9c04-1b89313ed379.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a granite countertop, a rolled towel, and decorative orchids. The toilet and shower with a decorative curtain complete the space.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, toilet, and shower with patterned curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (9).jpg"
    },
    {
      "id": "ec_ba87e078b68755357888101c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-c24f-75dd-9e95-f9eb77798a1d.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large windows.",
        "public_id": "019d0219-c24f-75dd-9e95-f9eb77798a1d",
        "storage_key": "property/6767906449167161/019d0219-c24f-75dd-9e95-f9eb77798a1d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and large windows that let in plenty of natural light. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with fireplace and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (10).jpg"
    },
    {
      "id": "ec_cde484fca9fd6668670976a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-c1cc-745f-9431-eb3d3add5dbe.webp",
      "image_media": {
        "alt_text": "Spacious living room with neutral carpet, three large windows, and a glass door.",
        "public_id": "019d0219-c1cc-745f-9431-eb3d3add5dbe",
        "storage_key": "property/6767906449167161/019d0219-c1cc-745f-9431-eb3d3add5dbe.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy the natural light in this expansive living area, perfect for relaxation and entertaining. Features plush carpeting and easy access to the outdoors.",
      "link": "false",
      "alt_text": "Spacious living room with neutral carpet, three large windows, and a glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (11).jpg"
    },
    {
      "id": "ec_e04b64804d361f28f1bbfc67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-cb5f-74dc-af34-96384850f4ef.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and kitchen area in apartment.",
        "public_id": "019d0219-cb5f-74dc-af34-96384850f4ef",
        "storage_key": "property/6767906449167161/019d0219-cb5f-74dc-af34-96384850f4ef.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room with a fireplace, complemented by an open kitchen area featuring modern appliances and granite countertops.",
      "link": "false",
      "alt_text": "Living room with fireplace and kitchen area in apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (12).jpg"
    },
    {
      "id": "ec_595b3bc1711d7b508d087e7b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-cfd1-7152-9bf2-abf2aed90073.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a closet and two doors.",
        "public_id": "019d0219-cfd1-7152-9bf2-abf2aed90073",
        "storage_key": "property/6767906449167161/019d0219-cfd1-7152-9bf2-abf2aed90073.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and plush carpeting, offering a blank canvas for your personal style.",
      "link": "false",
      "alt_text": "Empty bedroom with a closet and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (13).jpg"
    },
    {
      "id": "ec_cbbebf686c01f5bdf0684269",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-d03f-7183-be19-1b3be568c404.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment bedroom with closet",
        "public_id": "019d0219-d03f-7183-be19-1b3be568c404",
        "storage_key": "property/6767906449167161/019d0219-d03f-7183-be19-1b3be568c404.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A spacious apartment bedroom featuring carpeted flooring, neutral paint, and a large closet. Two interior doors lead to other parts of the unit.",
      "link": "false",
      "alt_text": "Interior view of an apartment bedroom with closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (14).jpg"
    },
    {
      "id": "ec_6e3bae36fb6e50febaa666d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-d3b2-76dc-9784-cb5171f9a5f7.webp",
      "image_media": {
        "alt_text": "Empty room with a closed door and blinds on the window.",
        "public_id": "019d0219-d3b2-76dc-9784-cb5171f9a5f7",
        "storage_key": "property/6767906449167161/019d0219-d3b2-76dc-9784-cb5171f9a5f7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A view of an empty room featuring a closed white door and a window with white blinds.",
      "link": "false",
      "alt_text": "Empty room with a closed door and blinds on the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (15).jpg"
    },
    {
      "id": "ec_f0d4bf431bb58c7bb816f489",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-dba9-7099-8df8-62262c304b43.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d0219-dba9-7099-8df8-62262c304b43",
        "storage_key": "property/6767906449167161/019d0219-dba9-7099-8df8-62262c304b43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (16).jpg"
    },
    {
      "id": "ec_6fde8bd66ee515494d0ee1fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-df03-70e3-9a7f-065a2b2c673c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with red lounge chairs and umbrellas.",
        "public_id": "019d0219-df03-70e3-9a7f-065a2b2c673c",
        "storage_key": "property/6767906449167161/019d0219-df03-70e3-9a7f-065a2b2c673c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and vibrant umbrellas for a perfect day in the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with red lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (17).jpg"
    },
    {
      "id": "ec_7197cce77da60166999d7558",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-df1c-73bd-874c-c7f95c639a3e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with red lounge chairs and umbrellas, and a brick building in the background.",
        "public_id": "019d0219-df1c-73bd-874c-c7f95c639a3e",
        "storage_key": "property/6767906449167161/019d0219-df1c-73bd-874c-c7f95c639a3e.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, furnished with comfortable lounge chairs and vibrant red umbrellas. Perfect for soaking up the sun and enjoying the beautiful weather.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with red lounge chairs and umbrellas, and a brick building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (18).jpg"
    },
    {
      "id": "ec_8ec10addecf8197123d54b35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-e6c8-776c-8c83-926bf00bf7b6.webp",
      "image_media": {
        "alt_text": "Modern seating area with sectional sofa, armchairs, coffee table, and decorative plants.",
        "public_id": "019d0219-e6c8-776c-8c83-926bf00bf7b6",
        "storage_key": "property/6767906449167161/019d0219-e6c8-776c-8c83-926bf00bf7b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge featuring comfortable seating, elegant decor, and a welcoming atmosphere. Perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Modern seating area with sectional sofa, armchairs, coffee table, and decorative plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (19).jpg"
    },
    {
      "id": "ec_d6a8847793bd702339a15002",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-ee02-7109-943e-e3175b3298f2.webp",
      "image_media": {
        "alt_text": "Spacious apartment complex lobby with modern furniture, large artwork, and high ceilings.",
        "public_id": "019d0219-ee02-7109-943e-e3175b3298f2",
        "storage_key": "property/6767906449167161/019d0219-ee02-7109-943e-e3175b3298f2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in the elegant and comfortable lobby space, featuring stylish seating arrangements and impressive decor.",
      "link": "false",
      "alt_text": "Spacious apartment complex lobby with modern furniture, large artwork, and high ceilings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (20).jpg"
    },
    {
      "id": "ec_39a7c38a1ec8ef84f21c06ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-efa7-7781-917d-43e48e54b8af.webp",
      "image_media": {
        "alt_text": "Lobby seating area with couches, accent chairs, and a coffee table.",
        "public_id": "019d0219-efa7-7781-917d-43e48e54b8af",
        "storage_key": "property/6767906449167161/019d0219-efa7-7781-917d-43e48e54b8af.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring comfortable seating and a stylish design.",
      "link": "false",
      "alt_text": "Lobby seating area with couches, accent chairs, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (21).jpg"
    },
    {
      "id": "ec_1daa64e113df6eaca745bd79",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-f4c2-7508-b067-c5f482735d0d.webp",
      "image_media": {
        "alt_text": "Lobby area with modern red chairs and tables, artwork on walls, and entrance visible.",
        "public_id": "019d0219-f4c2-7508-b067-c5f482735d0d",
        "storage_key": "property/6767906449167161/019d0219-f4c2-7508-b067-c5f482735d0d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the stylish lobby with comfortable seating and modern art. The entrance offers a view of the serene outdoors.",
      "link": "false",
      "alt_text": "Lobby area with modern red chairs and tables, artwork on walls, and entrance visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (22).jpg"
    },
    {
      "id": "ec_79a6bd325046f710e93a83ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-f97a-706d-bcb8-6218a24b48fd.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a paved walkway through manicured lawns and mature trees under a blue sky.",
        "public_id": "019d0219-f97a-706d-bcb8-6218a24b48fd",
        "storage_key": "property/6767906449167161/019d0219-f97a-706d-bcb8-6218a24b48fd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround the apartment buildings, offering residents serene walking paths and lush green spaces for relaxation and enjoyment.",
      "link": "false",
      "alt_text": "Apartment building exterior with a paved walkway through manicured lawns and mature trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (23).jpg"
    },
    {
      "id": "ec_bb52eb3a4ec81a6a81ff2487",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d0219-fdb8-70ec-b02c-cfcd9992554e.webp",
      "image_media": {
        "alt_text": "Park-like setting with benches, picnic tables, and a stone pathway.",
        "public_id": "019d0219-fdb8-70ec-b02c-cfcd9992554e",
        "storage_key": "property/6767906449167161/019d0219-fdb8-70ec-b02c-cfcd9992554e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our serene park-like setting, featuring comfortable benches, convenient picnic tables, and a charming stone pathway for leisurely strolls. Perfect for relaxation and enjoying nature.",
      "link": "false",
      "alt_text": "Park-like setting with benches, picnic tables, and a stone pathway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/MN_The-Fairways_Favorites (24).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cdebdc35-3b7b-4554-881f-5a9cc4c07d30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Topgolf Brooklyn Center",
      "poi_type": "Restaurants",
      "poi_address": "6420 Camden Ave N, Brooklyn Center, MN 55430, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun driving range with various games and targets, and the chicken bacon ranch flatbread is a popular choice. They also highlight the attentive and helpful staff, and the enjoyable experience for groups and families.\n\nOther reviews mention the food can be mediocre.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-7f01-71bf-8e7e-481874d76548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-7f01-71bf-8e7e-481874d76548",
        "storage_key": "property/6767906449167161/019d021a-7f01-71bf-8e7e-481874d76548.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/minneapolis/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10282037935290381734&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-brooklyn-center",
      "poi_latitude": "45.07124229999999",
      "poi_longitude": "-93.2880374",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 763-201-9636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba37-7000-b6ca-e0c5f38e1a96",
        "storage_key": "property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp--r8IUxs1IRpvUSjAYjsY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5bda4ff2-baf0-47a7-be58-77e230b7e18c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2780 Main St NW, Coon Rapids, MN 55448, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and country fried chicken, and the rolls with cinnamon butter are a highlight. They highlight the generous portions and reasonable prices. They also like the fun, lively atmosphere and the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-fcd4-747a-b555-ded7a98c3c02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-fcd4-747a-b555-ded7a98c3c02",
        "storage_key": "property/6767906449167161/019d021a-fcd4-747a-b555-ded7a98c3c02.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/minnesota/coon-rapids?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12039951827394943950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "45.196439",
      "poi_longitude": "-93.3375698",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 763-862-3389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba37-7000-b6ca-e0c5f38e1a96",
        "storage_key": "property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbFX10I8s1IRztuwiGWAFqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1fe0fbe0-2189-43c8-a1c2-8a9a3542b369",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Malone's Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "12635 Elm Creek Blvd N, Maple Grove, MN 55369, USA",
      "poi_short_description": "Easygoing place offering draft beers, cocktails & casual global grub, plus sports on TV & a patio.",
      "poi_long_description": "Diners say this bar and grill serves up delicious buffalo chicken wraps, waffle fries, and ribs. They also highlight the friendly and attentive service, lively atmosphere, and great happy hour deals on food and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-fab8-72ad-90f6-bcdff14c0b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-fab8-72ad-90f6-bcdff14c0b55",
        "storage_key": "property/6767906449167161/019d021a-fab8-72ad-90f6-bcdff14c0b55.webp",
        "width": 1067,
        "height": 1280
      },
      "poi_business_url": "http://www.malonesbarandgrill.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12905458706071380342&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "malones-bar--grill",
      "poi_latitude": "45.0939442",
      "poi_longitude": "-93.44118",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 763-447-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-bab3-7536-84ef-5d8cc6bb1293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-bab3-7536-84ef-5d8cc6bb1293",
        "storage_key": "property/6767906449167161/019d021a-bab3-7536-84ef-5d8cc6bb1293.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2bERAFIs1IRdmHbLlFmGbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_dd416c13-3ce6-4bbf-aa18-f84b220192bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Dave & Buster's Maple Grove",
      "poi_type": "Restaurants",
      "poi_address": "11780 Fountains Way, Maple Grove, MN 55369, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers a wide variety of arcade games and a fun atmosphere. They also highlight the good food and fast service.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-fd54-73d8-9488-5e28a9ca547f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-fd54-73d8-9488-5e28a9ca547f",
        "storage_key": "property/6767906449167161/019d021a-fd54-73d8-9488-5e28a9ca547f.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/maple-grove",
      "poi_directions_map_url": "https://maps.google.com/?cid=14147465087856669616&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-maple-grove",
      "poi_latitude": "45.0931949",
      "poi_longitude": "-93.42879560000002",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-493-9815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba37-7000-b6ca-e0c5f38e1a96",
        "storage_key": "property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrXeNLfo3s1IRsPPveYrkVcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d6346860-0b16-4748-8da4-5200dcebfac7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11820 Fountains Way, Maple Grove, MN 55369, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, fries, and shakes. They also highlight the friendly and helpful staff, and the fast service.\n\nOther reviews mention orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-fe56-738b-8972-a60f12ec3354.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-fe56-738b-8972-a60f12ec3354",
        "storage_key": "property/6767906449167161/019d021a-fe56-738b-8972-a60f12ec3354.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/mn/maple-grove?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17291114366894944807&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.0942304",
      "poi_longitude": "-93.4297126",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 763-307-0375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba37-7000-b6ca-e0c5f38e1a96",
        "storage_key": "property/6767906449167161/019d021a-ba37-7000-b6ca-e0c5f38e1a96.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS8Mrcvk3s1IRJzJtiedg9u8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_4200cdd7-7bc4-4a76-9f92-f43e1c3f4b5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12105 Elm Creek Blvd N, Maple Grove, MN 55369, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, unique and original items, and healthy, whole food options, including vegetarian and gluten-free choices. They highlight the affordable prices, especially for signature items, and the convenient location. They also like the friendly and helpful staff, and the fast checkout service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-066e-71ce-8827-09e02ae314e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-066e-71ce-8827-09e02ae314e5",
        "storage_key": "property/6767906449167161/019d021b-066e-71ce-8827-09e02ae314e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/mn/maple-grove/713/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12265767660248340956&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "45.0921072",
      "poi_longitude": "-93.4340104",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-315-1739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-be7f-7678-878c-c4f1ee734e66",
        "storage_key": "property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJud1D4gFIs1IR3JmTPrPCOKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e7446c71-442a-441a-abc9-db47bddc5de1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12201 Elm Creek Blvd N, Maple Grove, MN 55369, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy foods, including fresh herbs, cottage cheese, and bread. They also highlight the friendly and helpful staff, and the welcoming environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-0769-748b-874c-3ee82dcdf9f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-0769-748b-874c-3ee82dcdf9f6",
        "storage_key": "property/6767906449167161/019d021b-0769-748b-874c-3ee82dcdf9f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/maplegrove?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666727631345313547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "45.0913339",
      "poi_longitude": "-93.4358162",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-416-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-be7f-7678-878c-c4f1ee734e66",
        "storage_key": "property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-Oqnv03s1IRC2eGAnocTOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c77a7cea-def2-45bf-8477-ef10e2c39cdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Sun Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "6350 Brooklyn Blvd, Brooklyn Center, MN 55429, USA",
      "poi_short_description": "Busy market, featuring Asian staples, fresh fish and produce, and a selection of ethnic ingredients (African, Indian, Jamaican), plus dry goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh produce, seafood, meats, frozen foods, snacks, and hard-to-find ingredients. They also highlight the reasonable prices, convenient parking, and the summer farmers market.\n\nSome reviews mention there can be an unpleasant smell.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-077b-710e-bcd0-312846859439.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-077b-710e-bcd0-312846859439",
        "storage_key": "property/6767906449167161/019d021b-077b-710e-bcd0-312846859439.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sunfoodsonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4957428646020530588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-foods",
      "poi_latitude": "45.0704534",
      "poi_longitude": "-93.3258716",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 763-560-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-be7f-7678-878c-c4f1ee734e66",
        "storage_key": "property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSB8jOYws1IRnEFmhRZTzEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_819db747-a82b-4fd3-a7bc-e3cbe5e25aa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Dragon Star Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "Parksquare Shopping Center, 8020 Brooklyn Blvd, Brooklyn Park, MN 55445, USA",
      "poi_short_description": "Grocery store stocking international foods like Asian items, plus spices, kitchen utensils and cooking equipment.",
      "poi_long_description": "People say this supermarket offers a wide variety of international foods, including Asian, African, and European options, as well as a large selection of meats, seafood, and spices. They also highlight the good prices on meat and fish, and the availability of a hot food area.\n\nSome reviews mention the produce quality can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-0918-763d-9c23-086c1c356f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-0918-763d-9c23-086c1c356f34",
        "storage_key": "property/6767906449167161/019d021b-0918-763d-9c23-086c1c356f34.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://dragonstarmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7402611771152230970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dragon-star-supermarket",
      "poi_latitude": "45.0966701",
      "poi_longitude": "-93.3778536",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 763-315-4322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-be7f-7678-878c-c4f1ee734e66",
        "storage_key": "property/6767906449167161/019d021a-be7f-7678-878c-c4f1ee734e66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJge7A5WA3s1IROmqnZS9cu2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8427474e-9335-477e-8917-d08bcb740de9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6701 Boone Ave N, Brooklyn Park, MN 55428, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of home-building materials and garden items. They also highlight the reasonable prices and convenient location.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-0e4f-75ba-855e-ca94cb43383b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-0e4f-75ba-855e-ca94cb43383b",
        "storage_key": "property/6767906449167161/019d021b-0e4f-75ba-855e-ca94cb43383b.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.homedepot.com/l/Brooklyn-Park/MN/Brooklyn-Park/55428/2804?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14712608459240318846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "45.077082",
      "poi_longitude": "-93.3937995",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-533-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-be7f-7678-878c-cab5bdeae4b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-be7f-7678-878c-cab5bdeae4b0",
        "storage_key": "property/6767906449167161/019d021a-be7f-7678-878c-cab5bdeae4b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxys2gqA3s1IRfidtZHGvLcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_524bbc05-48ab-4b3e-b5cf-29f4650fc72d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Anoka-Ramsey Community College Coon Rapids Campus",
      "poi_type": "Education",
      "poi_address": "11200 Mississippi Blvd NW, Coon Rapids, MN 55433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-1013-749d-bd1b-a40be42322f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-1013-749d-bd1b-a40be42322f7",
        "storage_key": "property/6767906449167161/019d021b-1013-749d-bd1b-a40be42322f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.anokaramsey.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2754572954584658847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anoka-ramsey-community-college-coon-rapids-campus",
      "poi_latitude": "45.1743046",
      "poi_longitude": "-93.3513889",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 763-433-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3b1-7199-910a-7e5749f06997",
        "storage_key": "property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_0NBvc7s1IRn7PqAYI1OiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_de37823f-03e4-484a-85fe-c2ae40cc94d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "North Hennepin Community College",
      "poi_type": "Education",
      "poi_address": "7411 85th Ave N, Brooklyn Park, MN 55445, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-6fef-731a-80e6-344155eefe87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-6fef-731a-80e6-344155eefe87",
        "storage_key": "property/6767906449167161/019d021a-6fef-731a-80e6-344155eefe87.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nhcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968056009594297045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-hennepin-community-college",
      "poi_latitude": "45.1080226",
      "poi_longitude": "-93.3758026",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 763-488-0391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3b1-7199-910a-7e5749f06997",
        "storage_key": "property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVY4jT-Y5s1IR1dponVbumd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5f1125ec-d6b2-4023-981e-e273750c4af8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Hennepin Technical College",
      "poi_type": "Education",
      "poi_address": "9000 Brooklyn Blvd, Brooklyn Park, MN 55445, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ac9d-7668-acf9-124288d6b5cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-ac9d-7668-acf9-124288d6b5cd",
        "storage_key": "property/6767906449167161/019d021a-ac9d-7668-acf9-124288d6b5cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hennepintech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=87999848256665589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hennepin-technical-college",
      "poi_latitude": "45.0968573",
      "poi_longitude": "-93.3976883",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 952-995-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3b1-7199-910a-7e5749f06997",
        "storage_key": "property/6767906449167161/019d021a-c3b1-7199-910a-7e5749f06997.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-7CSUX83s1IR9XegT2WjOAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f7297e94-629e-4c87-bbd9-d1e26ce1ee92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "10900 Fountains Dr Suite 130, Maple Grove, MN 55369, USA",
      "poi_short_description": "Bright, kid-friendly place offering slides, basketball, trampoline parks and bouncy basketball, plus a cafe.",
      "poi_long_description": "People say this amusement park offers a wide variety of slides, a dodgeball court, and a basketball area. They also highlight the fun and unique experience, and the friendly and helpful staff.\n\nOther reviews mention the check-in process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-1303-73d4-939b-d0dbfa8f2cc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-1303-73d4-939b-d0dbfa8f2cc0",
        "storage_key": "property/6767906449167161/019d021b-1303-73d4-939b-d0dbfa8f2cc0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/mn-maple-grove",
      "poi_directions_map_url": "https://maps.google.com/?cid=13445167411640088829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "45.0925754",
      "poi_longitude": "-93.4187446",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 763-373-3155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VlSSpg3s1IR_Th3fIbUlro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_4ab7d0e8-1272-43b6-a4b1-cca8fa0496d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "10 Coon Rapids Blvd NW, Coon Rapids, MN 55448, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, climbing walls, and a zip line. They also highlight the friendly and helpful staff, and the clean and well-maintained facility.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-149a-73c8-92a1-78c8a36f3981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-149a-73c8-92a1-78c8a36f3981",
        "storage_key": "property/6767906449167161/019d021b-149a-73c8-92a1-78c8a36f3981.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/minnesota-coon-rapids/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11562750662305351590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "45.1306011",
      "poi_longitude": "-93.2681324",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 763-244-1701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TnZdiUls1IRpocfHXckd6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8be07011-0090-4f5d-bde6-ee3f2514c0f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "New Hope Aquatic Park",
      "poi_type": "Entertainment",
      "poi_address": "Civic Center Park, 4411 Xylon Ave N, New Hope, MN 55427, USA",
      "poi_short_description": "Family-friendly water park with a lazy river, slides and diving boards.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-167a-756e-a4ee-5fa9ca4c7669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-167a-756e-a4ee-5fa9ca4c7669",
        "storage_key": "property/6767906449167161/019d021b-167a-756e-a4ee-5fa9ca4c7669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newhopemn.gov/cms/One.aspx?portalId=9826709&pageId=11244896",
      "poi_directions_map_url": "https://maps.google.com/?cid=9424646355599234637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "new-hope-aquatic-park",
      "poi_latitude": "45.0359039",
      "poi_longitude": "-93.3864361",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 763-531-5177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cFtKRU3s1IRTRYsL-0Ry4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_8493b626-588d-454a-b307-6439afb4f088",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Venetian Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "11801 Fountains Way, Maple Grove, MN 55369, USA",
      "poi_short_description": "Indoor venue at the Holiday Inn features pools, slides & an elaborate Venetian cityscape theme.",
      "poi_long_description": "Indoor venue at the Holiday Inn features pools, slides & an elaborate Venetian cityscape theme.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-19d6-709c-96c6-2daa77b5e512.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-19d6-709c-96c6-2daa77b5e512",
        "storage_key": "property/6767906449167161/019d021b-19d6-709c-96c6-2daa77b5e512.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.venetianwaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3339356898217859837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "venetian-waterpark",
      "poi_latitude": "45.091609",
      "poi_longitude": "-93.42966400000002",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-425-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtdxASvo3s1IR_ZqGAGjHVy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_a262c930-3bec-4ac2-8080-002d870e9ca5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Mounds View Splash Down Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "2401 Mounds View Blvd, Mounds View, MN 55112, USA",
      "poi_short_description": "Family-friendly space featuring a splash pad and a playground, plus picnic tables and benches.",
      "poi_long_description": "People say this water park offers a fun splash pad with multiple features and a playground. They highlight the free admission, clean facilities, and ample space for picnics and birthday parties. They also like the convenient parking and nearby police station for added safety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-1c11-77bc-bb06-0afa842ec2e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-1c11-77bc-bb06-0afa842ec2e3",
        "storage_key": "property/6767906449167161/019d021b-1c11-77bc-bb06-0afa842ec2e3.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "https://www.moundsviewmn.org/government/city_departments/parks_and_recreation/city_parks/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=11076111201387051599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mounds-view-splash-down-splash-pad",
      "poi_latitude": "45.1047039",
      "poi_longitude": "-93.2043669",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ519bZC4ls1IRT3pmM3RAtpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_4bd8d84f-5a7f-46ca-8c1a-0ce9e2cb2546",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Los Campeones Gym Brooklyn Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6440 James Cir N, Brooklyn Center, MN 55430, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment, including machines, free weights, and powerlifting platforms, and has a spacious layout. They highlight the clean and well-maintained facilities, and the intense, no-frills atmosphere rooted in traditional bodybuilding culture. They also like the friendly and helpful staff, and the community-driven vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-20c3-71ad-80eb-08eb7158fa46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-20c3-71ad-80eb-08eb7158fa46",
        "storage_key": "property/6767906449167161/019d021b-20c3-71ad-80eb-08eb7158fa46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.loscampeonesgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10802138825728128188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "los-campeones-gym-brooklyn-center",
      "poi_latitude": "45.0723048",
      "poi_longitude": "-93.3034698",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 763-205-0666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyk388Exs1IRvPT6oQfo6JU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6b63445c-518d-49a9-8f21-b6c8cfcaed47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "12601 82nd Ave N, Maple Grove, MN 55369, USA",
      "poi_short_description": "Athletic country club and gym within the Maple Grove Community Center offering an extensive fitness floor, unlimited group exercise classes, and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of workout options, including yoga, Pilates, and barbell strength classes. They also highlight the knowledgeable and friendly staff, and the clean and comfortable environment.\n\nOther reviews mention the facilities can be closed early.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-2198-7330-a19f-60572d2f07f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-2198-7330-a19f-60572d2f07f3",
        "storage_key": "property/6767906449167161/019d021b-2198-7330-a19f-60572d2f07f3.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/mn/maple-grove.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=9741760046857153561&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.1034454",
      "poi_longitude": "-93.4414074",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-420-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-frI_lHs1IRGWwDCCavMYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_af876b8b-d4f5-4e20-9385-cfda36001bcd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6600 96th Ln N, Brooklyn Park, MN 55445, USA",
      "poi_short_description": "Standard chain gym with fitness equipment and a pool, plus some racquetball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-9320-736c-9c8a-2eccb255815e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-9320-736c-9c8a-2eccb255815e",
        "storage_key": "property/6767906449167161/019d021a-9320-736c-9c8a-2eccb255815e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=434&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15712081590579406704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.1312514",
      "poi_longitude": "-93.3620179",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 763-515-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3udHIc5s1IRcKdw4PWGDNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8eec2cc3-4d21-4e43-9c29-45f8f2bd9f12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12059 Elm Creek Blvd N, Maple Grove, MN 55369, USA",
      "poi_short_description": "Membership-only gym chain offering a variety of equipment, massage chairs, and tanning services.",
      "poi_long_description": "People say this gym offers a variety of equipment and amenities, including hydro massage chairs and beds. They also highlight the friendly staff and clean environment.\n\nOther reviews mention some equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-929a-7006-aa52-a1b1e05a7629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-929a-7006-aa52-a1b1e05a7629",
        "storage_key": "property/6767906449167161/019d021a-929a-7006-aa52-a1b1e05a7629.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/maple-grove-mn?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13428218150028289684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.0927572",
      "poi_longitude": "-93.4331158",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-205-6918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7IySDU3s1IRlKbj_kKdWro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e4362fee-f951-4f2a-9512-1a8ff8860f7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "New Hope YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "7601 N 42nd Ave, New Hope, MN 55427, USA",
      "poi_short_description": "Chain, gym and fitness centre featuring a basketball court, an indoor pool and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-2561-72fb-9e67-2a0f9a2450cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-2561-72fb-9e67-2a0f9a2450cb",
        "storage_key": "property/6767906449167161/019d021b-2561-72fb-9e67-2a0f9a2450cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcanorth.org/locations/new_hope_ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=10002750721473734171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "new-hope-ymca",
      "poi_latitude": "45.0316955",
      "poi_longitude": "-93.3773779",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 763-535-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-x7M95o2s1IRG2Y5ysjo0Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a6eb0011-e7f3-4acd-8a70-cb0d8ef3f469",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Mercy Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4050 Coon Rapids Blvd, Coon Rapids, MN 55433, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-8755-73c8-9945-128fb894bac7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-8755-73c8-9945-128fb894bac7",
        "storage_key": "property/6767906449167161/019d021a-8755-73c8-9945-128fb894bac7.webp",
        "width": 657,
        "height": 437
      },
      "poi_business_url": "https://account.allinahealth.org/locations/380?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Mercy-Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9385238481084026423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital",
      "poi_latitude": "45.1829386",
      "poi_longitude": "-93.3688433",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 763-236-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3f7-7678-a8a0-4f7f125c2667.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3f7-7678-a8a0-4f7f125c2667",
        "storage_key": "property/6767906449167161/019d021a-c3f7-7678-a8a0-4f7f125c2667.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Qr6l6g-s1IRNw5XZawQP4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_32a3734f-4379-43bc-a0dd-82427484ffba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Mercy Hospital – Unity Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Osborne Rd NE, Fridley, MN 55432, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-29bf-7689-bd2d-b942a358c4eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-29bf-7689-bd2d-b942a358c4eb",
        "storage_key": "property/6767906449167161/019d021b-29bf-7689-bd2d-b942a358c4eb.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://account.allinahealth.org/locations/764?utm_source=gmb&utm_medium=organic&utm_content=web-url&utm_campaign=gmb_website&utm_term=Mercy-Hospital-Unity-Campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=9398771758297471517&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital--unity-campus",
      "poi_latitude": "45.106475",
      "poi_longitude": "-93.2569652",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 763-236-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3f7-7678-a8a0-4f7f125c2667.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3f7-7678-a8a0-4f7f125c2667",
        "storage_key": "property/6767906449167161/019d021a-c3f7-7678-a8a0-4f7f125c2667.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Sa-QV4ls1IRHVpLCh4lb4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f723d696-103b-4620-88a9-fdbdfdf1e917",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Elm Creek Park Reserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12400 James Deane Pkwy, Maple Grove, MN 55369, USA",
      "poi_short_description": "4,900 acres with nature center, camping cabins & activities including hiking, swimming & disc golf.",
      "poi_long_description": "People say this nature preserve offers hiking, biking, and walking trails, as well as a playground and picnic areas. They highlight the beautiful scenery, the variety of outdoor activities, and the well-maintained trails. They also like the convenient location and the availability of both paved and unpaved trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-9f62-7788-8e23-a8949d384e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-9f62-7788-8e23-a8949d384e23",
        "storage_key": "property/6767906449167161/019d021a-9f62-7788-8e23-a8949d384e23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.threeriversparks.org/location/elm-creek-park-reserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=16796324542085390037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elm-creek-park-reserve",
      "poi_latitude": "45.1379829",
      "poi_longitude": "-93.4378898",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 763-694-7894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c914-75b8-bcf0-61ae9149725d",
        "storage_key": "property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yBUaqk4s1IR1d4sJy6IGOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_0f709a98-297a-4c62-bfc1-fa00dd941d59",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Edinburgh Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8700 Edinbrook Crossing, Brooklyn Park, MN 55443, USA",
      "poi_short_description": "18-hole public golf course featuring practice facilities, a restaurant & a pro shop.",
      "poi_long_description": "People say this golf course offers a challenging and fun layout with firm greens and carefully selected pins. They also highlight the beautiful, Scottish castle-like clubhouse, the well-maintained course conditions, and the friendly staff.\n\nOther reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-7261-76ae-a600-54339ea36486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-7261-76ae-a600-54339ea36486",
        "storage_key": "property/6767906449167161/019d021a-7261-76ae-a600-54339ea36486.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edinburghusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15091647581166527408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edinburgh-golf-course",
      "poi_latitude": "45.11226629999999",
      "poi_longitude": "-93.326914",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 763-315-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c3b1-7199-910a-81576d7aca5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c3b1-7199-910a-81576d7aca5d",
        "storage_key": "property/6767906449167161/019d021a-c3b1-7199-910a-81576d7aca5d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5mhnGY6s1IRsGPQHoRNcNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7d279cb0-a5bd-4302-9920-4023bf73b0a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Central Park of Maple Grove",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12000 Central Park Way, Maple Grove, MN 55369, USA",
      "poi_short_description": "Urban park with a playground for all ages, plus a seasonal, interactive fountain & ice-skating loop.",
      "poi_long_description": "People say this park offers a variety of activities, including a playground, splash pad, skating rink, and walking trails. They highlight the well-maintained facilities, the fun and engaging atmosphere for children, and the ample space for picnics and gatherings. They also like the convenient amenities, such as restrooms, shaded seating areas, and a concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-2fab-74a8-8df7-bdcbff11e618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-2fab-74a8-8df7-bdcbff11e618",
        "storage_key": "property/6767906449167161/019d021b-2fab-74a8-8df7-bdcbff11e618.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.maplegrovemn.gov/505/Central-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2223011269586513210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-park-of-maple-grove",
      "poi_latitude": "45.1017471",
      "poi_longitude": "-93.4335566",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 763-494-6474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c914-75b8-bcf0-61ae9149725d",
        "storage_key": "property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqagQ4s1IROu1kv_i42R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9ab328f0-b5f3-4436-9cac-968077e39aa2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Mississippi Gateway Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10360 W River Rd, Brooklyn Park, MN 55444, USA",
      "poi_short_description": "Scenic expanse of the Mississippi River with a dam & observation deck, picnic areas & hiking trails.",
      "poi_long_description": "People say this park offers beautiful trails for walking, running, and biking, as well as opportunities for fishing and picnicking. They highlight the scenic views of the dam and river, and the peaceful atmosphere. They also like the ongoing renovations and upgrades, including new buildings and a playground. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-9ce1-734d-a540-62aedb84e4fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-9ce1-734d-a540-62aedb84e4fe",
        "storage_key": "property/6767906449167161/019d021a-9ce1-734d-a540-62aedb84e4fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.threeriversparks.org/location/mississippi-gateway-regional-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14005355540822427867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-gateway-regional-park",
      "poi_latitude": "45.1369623",
      "poi_longitude": "-93.311266",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 763-694-7790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c914-75b8-bcf0-61ae9149725d",
        "storage_key": "property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLW14wAQ7s1IR2wjFK6kEXcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8691a90b-40d4-43e9-b521-1894a0410e2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Coon Rapids Dam Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9750 Egret Blvd NW, Coon Rapids, MN 55433, USA",
      "poi_short_description": "Dam featuring a walkway and scenic views along with paved trails for biking and hikes.",
      "poi_long_description": "People say this park offers well-maintained walking trails, beautiful scenery, and opportunities for fishing. They highlight the relaxing and rejuvenating atmosphere, and the family-friendly amenities such as restrooms and a playground. They also like the friendly staff and the clean guest center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-2fab-74a8-8df7-c0d8a44ba7db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-2fab-74a8-8df7-c0d8a44ba7db",
        "storage_key": "property/6767906449167161/019d021b-2fab-74a8-8df7-c0d8a44ba7db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anokacountyparks.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15721529398525840732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coon-rapids-dam-regional-park",
      "poi_latitude": "45.1468356",
      "poi_longitude": "-93.3096446",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 763-324-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c914-75b8-bcf0-61ae9149725d",
        "storage_key": "property/6767906449167161/019d021a-c914-75b8-bcf0-61ae9149725d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6lzpho7s1IRXE3-FLEXLto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c1798be7-e2bc-4f75-8651-c2c7e85663a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Crystal Airport (KMIC)",
      "poi_type": "Transportation & Transit",
      "poi_address": "5800 Crystal Airport Rd, Minneapolis, MN 55429, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-2f43-706f-887f-0f2aeded537d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-2f43-706f-887f-0f2aeded537d",
        "storage_key": "property/6767906449167161/019d021b-2f43-706f-887f-0f2aeded537d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.metroairports.org/general-aviation/airports/crystal.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13154942210170259520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crystal-airport-kmic",
      "poi_latitude": "45.0607236",
      "poi_longitude": "-93.3555397",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 651-224-4306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c998-73ae-acc1-de76a062ab3f",
        "storage_key": "property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJVxiohtU2s1IRQIj9BT6-j7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d44eb3fc-b48c-4838-99f8-52e406835a91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Anoka County-Blaine Airport (Janes Field) Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "8891 Airport Rd NE, Blaine, MN 55449, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-31d6-725a-842e-00698f87402b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-31d6-725a-842e-00698f87402b",
        "storage_key": "property/6767906449167161/019d021b-31d6-725a-842e-00698f87402b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.metroairports.org/General-Aviation/Airports/Anoka-County-Blaine.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10771074512829126193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anoka-county-blaine-airport-janes-field-office",
      "poi_latitude": "45.142048",
      "poi_longitude": "-93.217556",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 763-717-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c998-73ae-acc1-de76a062ab3f",
        "storage_key": "property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3CKNjUks1IRMZZxqjOLepU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9d9324dd-50a8-45f1-be5e-15b89d235523",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Fridley",
      "poi_type": "Transportation & Transit",
      "poi_address": "6050 Main Street, Fridley, MN 55432, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-363b-7325-b85b-63f998463cf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-363b-7325-b85b-63f998463cf8",
        "storage_key": "property/6767906449167161/019d021b-363b-7325-b85b-63f998463cf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12160524456102998218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fridley",
      "poi_latitude": "45.07891799999999",
      "poi_longitude": "-93.270859",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 612-373-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-4737-743b-adb0-f52cffe02102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-4737-743b-adb0-f52cffe02102",
        "storage_key": "property/6767906449167161/019d021b-4737-743b-adb0-f52cffe02102.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-a_Rxdgvs1IRyjB4SJDcwqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_678f163b-bc9a-404b-87d2-dd0997091d8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Coon Rapids - Riverdale Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Coon Rapids, MN 55448, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-396c-763c-a965-4967f2409cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-396c-763c-a965-4967f2409cd8",
        "storage_key": "property/6767906449167161/019d021b-396c-763c-a965-4967f2409cd8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5649619720095406675&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coon-rapids---riverdale-station",
      "poi_latitude": "45.19096589999999",
      "poi_longitude": "-93.351195",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-4737-743b-adb0-f52cffe02102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-4737-743b-adb0-f52cffe02102",
        "storage_key": "property/6767906449167161/019d021b-4737-743b-adb0-f52cffe02102.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YjWghY8s1IRUxpU1DN7Z04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_4d89039b-0166-4897-beb4-41af91e77f67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Gopher VORTAC GEP 117.3",
      "poi_type": "Transportation & Transit",
      "poi_address": "Brooklyn Park, MN 55445, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-3988-7730-990f-efd95806cf61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-3988-7730-990f-efd95806cf61",
        "storage_key": "property/6767906449167161/019d021b-3988-7730-990f-efd95806cf61.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8889158489495079459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gopher-vortac-gep-1173",
      "poi_latitude": "45.1456962",
      "poi_longitude": "-93.3732059",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-c998-73ae-acc1-de76a062ab3f",
        "storage_key": "property/6767906449167161/019d021a-c998-73ae-acc1-de76a062ab3f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZR1PnA5s1IRI4qApoyiXHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0274776c-0212-448c-81a3-37068819bd5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Target North Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7000 Target Pkwy, Brooklyn Park, MN 55445, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ab9c-7689-814c-bf0469cbec32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021a-ab9c-7689-814c-bf0469cbec32",
        "storage_key": "property/6767906449167161/019d021a-ab9c-7689-814c-bf0469cbec32.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://corporate.target.com/careers/global-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15141494816397381284&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "target-north-campus",
      "poi_latitude": "45.1350735",
      "poi_longitude": "-93.3720978",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 612-304-6073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_KJtx4ts1IRpM7I-09lIdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7e762774-4536-403c-81c2-4a3df470d121",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Medtronic Rice Creek East",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6949 Central Ave NE #6901, Fridley, MN 55432, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-3c9b-7048-ab18-7c6ee3a52da5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-3c9b-7048-ab18-7c6ee3a52da5",
        "storage_key": "property/6767906449167161/019d021b-3c9b-7048-ab18-7c6ee3a52da5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10833598472520661589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medtronic-rice-creek-east",
      "poi_latitude": "45.0941328",
      "poi_longitude": "-93.2372389",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPTc_y5wvs1IRVfrOcWmsWJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_04d415b6-4cd0-4a3a-97ec-962e544ee276",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Polaris Industries",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9955 59th Ave N, Minneapolis, MN 55442, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-3c96-753a-8f7e-ba892fff2d77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-3c96-753a-8f7e-ba892fff2d77",
        "storage_key": "property/6767906449167161/019d021b-3c96-753a-8f7e-ba892fff2d77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.polaris.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16559872303553112912&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "polaris-industries",
      "poi_latitude": "45.0589411",
      "poi_longitude": "-93.4068153",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 763-542-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXV2VYkw2s1IRUOscQx980OU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0660d6a6-35d1-4e95-9f8b-425a8958860d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Boston Scientific Arbor Lakes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Boston Scientific Way, Maple Grove, MN 55369, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-3e94-70d4-8b11-70b12c790447.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-3e94-70d4-8b11-70b12c790447",
        "storage_key": "property/6767906449167161/019d021b-3e94-70d4-8b11-70b12c790447.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bostonscientific.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=303838817214272626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boston-scientific-arbor-lakes",
      "poi_latitude": "45.08697",
      "poi_longitude": "-93.4120134",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubyXQAA3s1IRchQIYctzNwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_90a47718-413e-488f-996a-98494f0a606a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "custom",
      "poi_name": "Philips",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5905 Nathan Ln N, Plymouth, MN 55442, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.philips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7571692327996433618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philips",
      "poi_latitude": "45.06000239999999",
      "poi_longitude": "-93.4106759",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-793-1261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021a-ba34-70f8-8e36-deaadf0d54d9",
        "storage_key": "property/6767906449167161/019d021a-ba34-70f8-8e36-deaadf0d54d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bcaBQ03s1IR0iTHRg4OFGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5e7fe6334d2401a0e69eb5ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f6080066a78b0b424589f5a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_239f919e31c857815c608adc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_082c36625ea1b7a1fd7bd5bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2734b1cbaf2fcad0dd964bbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0d94b0d4-e8ce-4e36-a7a4-8fcbf1b5c4a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "rating": "5.0",
      "name": "Angela C",
      "text": "Overall: I am very grateful for this place and for the amazing staff. I absolutely love my unit and the location is very convenient. They offer a $50 credit for going on their website and chatting with a current resident. I spoke with a resident prior to moving in and he answered all my questions and was very honest. If you are looking for an apartment in the area, I would highly recommend Fairways at Edinburgh!!\n\nPros:\n-Office staff, Hunter and Kuan are incredibly knowledgeable, personable, professional and prompt.\n-Maintenance requests are through Rent Cafe, so you are able to select the category/location of the request and add any comments. Maintenance is extremely prompt, professional and knowledgeable.\n-Neighbors are friendly. Anyone I come by, either engages in small talk or keeps to themselves.\nNeighbors are also fairly quiet inside and outside of the property.\n-I have not encountered any safety issues whatsoever.\n-My unit is very spacious and was deeply cleaned prior to moving in. I received a welcome basket upon move in and a birthday card — very thoughtful!!\n-Indoor and outdoor spaces are kept very clean from what I have observed.\n\nCons:\n-Underground garage spaces are a little tight if you drive a larger vehicle. Also, some blind spots in the garage when coming around corners. (Not everyone pays attention)\n-Your garage door remote is also used for the doors inside on the main level. It’s a little too bulky to put on my key ring, so if I forget it in my car, I am unable to use it on the door(s) by the main office after business hours unless I go to my car.\n-Rarely but sometimes hear dogs barking while walking in the hallways (dogs will be dogs, so no big deal). You can’t hear it inside your unit though!",
      "date": "2026-02-08",
      "title": ""
    },
    {
      "id": "custom_5aafeccb-7618-4f05-afb7-bbc01c0314bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "rating": "5.0",
      "name": "gebeh tarpeh",
      "text": "I have been living at fairways for 5 years and it’s a nice environment for kids and family. The building is nice and the maintenance crew are very responsive . The pool is very large and user friendly . Good thing is they have two party rooms. The gym is not a weight lifting one, but you can burn some calories running some of their nicer tread machines . If you are not looking to buy a house right now and want a safe and reliable environment, this might be your choice . 🫠😊",
      "date": "2024-03-21",
      "title": ""
    },
    {
      "id": "custom_5882ccc1-2fe1-4a28-8065-51d7701b9f94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "rating": "5.0",
      "name": "Alexandra",
      "text": "This place has been really pleasant to live in. The community is very nice and management is always friendly and responsive. Maintenance team are great workers and I truly appreciate the work the staff do to keep this place running for residents to comfortably live in.",
      "date": "2025-04-16",
      "title": ""
    },
    {
      "id": "custom_36b6e584-b510-4453-99e2-b4a34992472c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "rating": "5.0",
      "name": "Louise S. Holley",
      "text": "Ryan and the maintenance team are amazing. They do a great job here at the Fairways.\nQwan (sp?) has been great as the community director.",
      "date": "2025-07-22",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_06340b84a5dad88f7a82e739",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/5q8y1g?source=180"
    },
    {
      "id": "ec_d919494116e21e39ca9e1b11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-4f3d-71ed-a8ff-b56f89feb4f4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "A furnished living room and kitchen area in an apartment.",
        "public_id": "019d021b-4f3d-71ed-a8ff-b56f89feb4f4",
        "storage_key": "property/6767906449167161/019d021b-4f3d-71ed-a8ff-b56f89feb4f4.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA - 1,436 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=C1BgZ2UXmFJ"
    },
    {
      "id": "ec_63f1761489af30b068d9495f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-03eb-708a-9f64-93b58a97a0f3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious communal lounge area with modern furniture, a television, and decorative art.",
        "public_id": "019d021c-03eb-708a-9f64-93b58a97a0f3",
        "storage_key": "property/6767906449167161/019d021c-03eb-708a-9f64-93b58a97a0f3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WosopV6CBGb"
    },
    {
      "id": "ec_c1ad3d7ab22e063d09cfce77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-4fe5-71fd-95d8-af289445cc6e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills and elliptical machines.",
        "public_id": "019d021b-4fe5-71fd-95d8-af289445cc6e",
        "storage_key": "property/6767906449167161/019d021b-4fe5-71fd-95d8-af289445cc6e.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Fitness Center & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7rohbX5ZTQF"
    },
    {
      "id": "ec_3b7cd79b041e31ee2c23c9c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-5cac-70c0-a06e-de261d7d5bc7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Dining area and kitchen in a modern apartment, featuring a round table with chairs and dark wood cabinetry.",
        "public_id": "019d021b-5cac-70c0-a06e-de261d7d5bc7",
        "storage_key": "property/6767906449167161/019d021b-5cac-70c0-a06e-de261d7d5bc7.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA, Model - 1,090 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WHZU9ZKYnyK"
    },
    {
      "id": "ec_5cb87a62a8b941f110cf9f77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-5c8c-7069-a8a9-55a23192a3d6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "019d021b-5c8c-7069-a8a9-55a23192a3d6",
        "storage_key": "property/6767906449167161/019d021b-5c8c-7069-a8a9-55a23192a3d6.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA -1,139 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cQeFqBbTKaH"
    },
    {
      "id": "ec_bbf7f72ad64d43d97ccecebd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-0705-74a8-a6e8-8870db21ca7f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019d021c-0705-74a8-a6e8-8870db21ca7f",
        "storage_key": "property/6767906449167161/019d021c-0705-74a8-a6e8-8870db21ca7f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA, Arrowhead - 1,072 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AZgUgHJSLQG"
    },
    {
      "id": "ec_c9c6aea201327b61d3b12e5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-0a67-74b7-af21-9010ca7705c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark cabinetry and granite countertops, connected to a living area.",
        "public_id": "019d021c-0a67-74b7-af21-9010ca7705c9",
        "storage_key": "property/6767906449167161/019d021c-0a67-74b7-af21-9010ca7705c9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA, Augusta - 1,154 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zzaTvtrSEgB"
    },
    {
      "id": "ec_9ad7efd2a5db4079f67828da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-67f3-706a-ba94-ba36299ffeb2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Dining area and living room with modern furniture and large windows.",
        "public_id": "019d021b-67f3-706a-ba94-ba36299ffeb2",
        "storage_key": "property/6767906449167161/019d021b-67f3-706a-ba94-ba36299ffeb2.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BR, Cypress Point - 1,090 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iNr2pSiis3P"
    },
    {
      "id": "ec_2a2e8f2dc8abc63bf23b0210",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-0dc0-73ae-81fe-bdf4b1bd589e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d021c-0dc0-73ae-81fe-bdf4b1bd589e",
        "storage_key": "property/6767906449167161/019d021c-0dc0-73ae-81fe-bdf4b1bd589e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA, Coghill - 823 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5pnR8ZEsPoF"
    },
    {
      "id": "ec_e7979b1130ff8ebd98dc4951",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-101a-75ba-9b00-dd5ddeabd08c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and an island.",
        "public_id": "019d021c-101a-75ba-9b00-dd5ddeabd08c",
        "storage_key": "property/6767906449167161/019d021c-101a-75ba-9b00-dd5ddeabd08c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA, Pebble Beach - 1,159 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cgvd9hNjSwB"
    },
    {
      "id": "ec_c45a3b2c85fbc1cbb26e20a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-14ca-759e-b7c7-e311e1aa81db.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an unfurnished apartment showing a living area and kitchen.",
        "public_id": "019d021c-14ca-759e-b7c7-e311e1aa81db",
        "storage_key": "property/6767906449167161/019d021c-14ca-759e-b7c7-e311e1aa81db.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - 1,090 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7RAuYMD6Ygv"
    },
    {
      "id": "ec_1879192de473fdc6cb1913a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-73b1-7388-86ff-6f7e758f03de.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with a view into the kitchen.",
        "public_id": "019d021b-73b1-7388-86ff-6f7e758f03de",
        "storage_key": "property/6767906449167161/019d021b-73b1-7388-86ff-6f7e758f03de.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA - 1,159 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YAjxJSo7hSA"
    },
    {
      "id": "ec_4a165e8b75841bd05e70640d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021b-74a1-7608-8540-98e62aca8494.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living area with a kitchen pass-through and a galley kitchen.",
        "public_id": "019d021b-74a1-7608-8540-98e62aca8494",
        "storage_key": "property/6767906449167161/019d021b-74a1-7608-8540-98e62aca8494.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - 1,162 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hPKCaC3JX5D"
    },
    {
      "id": "ec_0e6a1d265cfac51b6971eaef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167161/019d021c-1be9-76cd-968b-a0ad3aa2c101.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living area with kitchen island and dark cabinets.",
        "public_id": "019d021c-1be9-76cd-968b-a0ad3aa2c101",
        "storage_key": "property/6767906449167161/019d021c-1be9-76cd-968b-a0ad3aa2c101.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA, Emerald Dunes - 1,162 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2Y2S4BNFwsD"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db66e-1622-755f-8108-15628988ffbe",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Fairways at Edinburgh",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-brooklyn-park-mn",
      "search_query": "pet friendly apartments Brooklyn Park MN",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Brooklyn Park, MN",
      "h2_subtitle": "Discover pet-friendly apartments in Brooklyn Park, MN, at The Fairways. Enjoy lush courtyards ideal for pet playtime and ample green spaces.",
      "page_copy": "Welcome to The Fairways, the top choice for pet-friendly apartments in Brooklyn Park, MN. Here, your furry friends are warmly welcomed as valued residents. Our lush courtyards provide plenty of room for them to roam, while private balconies offer a relaxing space for both you and your pet to soak up the sun. The added convenience of in-unit laundry ensures your pet's dirt-laden adventures can be swiftly handled.\n\nLocated in the heart of Brooklyn Park, The Fairways are not just pet-friendly—we're also people-friendly! Residents enjoy free on-site parking, ensuring easy comings and goings, and our community gatherings foster a welcoming atmosphere for all. Whether you have a playful pup or a cuddly cat, The Fairways is the perfect home base where both pets and their owners feel at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Brooklyn Park, MN",
      "seo_description": "The Fairways offer pet-friendly apartments in Brooklyn Park, MN. Enjoy lush courtyards and ample green spaces for pet playtime.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-hennepin-county",
      "search_query": "in unit laundry apartments Hennepin County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Hennepin County",
      "h2_subtitle": "Looking for in-unit laundry apartments in Hennepin County? The Fairways offer this convenience and more for a seamless living experience.",
      "page_copy": "Experience the convenience of modern living with our in-unit laundry apartments in Hennepin County at The Fairways. Gone are the days of hauling laundry baskets to communal facilities; here, you can manage your laundry from the comfort of your own home, freeing up more time for leisure and relaxation.\n\nThe Fairways, nestled in Brooklyn Park, combine convenience with comfort. Our pet-friendly community also features free on-site parking and serene, lush courtyards perfect for unwinding after a long day. Plus, each apartment comes with a private balcony, offering a personal outdoor retreat right at your doorstep. Consider The Fairways for your next home, where every detail is geared towards enhancing your quality of life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments, Hennepin County",
      "seo_description": "The Fairways offer in-unit laundry apartments in Hennepin County. Enjoy seamless living with modern amenities designed for convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "poolside-lounge-deck-apartments-55443",
      "search_query": "poolside lounge deck apartments 55443",
      "category": "Amenity",
      "h1_title": "Poolside Lounge Deck Apartments in 55443",
      "h2_subtitle": "Searching for poolside lounge deck apartments in the 55443 area? Discover relaxed living at The Fairways with tranquil outdoor spaces.",
      "page_copy": "Although the Fairways in Brooklyn Park doesn't feature a poolside lounge deck, we offer exceptional living spaces and serene courtyards that you'll love. Residents in the 55443 enjoy relaxing in our lush outdoor areas, ideal for unwinding or spending quality time with neighbors. Our commitment to providing premium features ensures a comfortable lifestyle for everyone in the community.\n\nLocated in beautiful Hennepin County, The Fairways offers a host of convenient amenities. Enjoy the luxury of in-unit laundry and free on-site parking—making everyday living a breeze. Pet-friendly and equipped with private balconies, our apartments provide a harmonious blend of relaxation and modern living, making them a perfect home base in the 55443 zip code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Lounge Deck Apartments in 55443",
      "seo_description": "Discover relaxed living at The Fairways in 55443. Enjoy lush courtyards and comfortable apartments, perfect for residents seeking tranquility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "reserved-parking-apartments-brooklyn-park",
      "search_query": "reserved parking apartments Brooklyn Park",
      "category": "Amenity",
      "h1_title": "Reserved Parking Apartments in Brooklyn Park",
      "h2_subtitle": "Explore reserved parking apartments in Brooklyn Park at The Fairways. Enjoy the convenience of free on-site parking and other great amenities.",
      "page_copy": "At The Fairways in Brooklyn Park, enjoy the convenience of reserved parking apartments designed to simplify your daily routine. While we offer free on-site parking rather than specifically reserved spaces, you'll always have easy access to transport without the hassle of searching for a spot. This feature ensures your busy days start and end with ease and convenience.\n\nLocated conveniently in Hennepin County, The Fairways provides a range of amenities. Each apartment comes with in-unit laundry, and our pet-friendly policies ensure every family member is welcomed. Relax in our lush courtyards or enjoy a sunny afternoon on your private balcony. Choose The Fairways for a hassle-free, comfortable living experience in Brooklyn Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reserved Parking Apartments, Brooklyn Park",
      "seo_description": "Find convenience with reserved parking apartments at The Fairways, Brooklyn Park. Enjoy free on-site parking and modern amenities for easy living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-brooklyn-park-mn",
      "search_query": "private balcony apartments in Brooklyn Park MN",
      "category": "Amenity",
      "h1_title": "Private Balcony Apartments in Brooklyn Park, MN",
      "h2_subtitle": "Discover private balcony apartments in Brooklyn Park, MN, at The Fairways. Enjoy your personal outdoor retreat with stunning courtyard views.",
      "page_copy": "The Fairways in Brooklyn Park, MN, offer exquisite private balcony apartments perfect for those seeking a personal slice of outdoor serenity. Each balcony provides the ideal setting to sip your morning coffee or unwind after a long day, with views that soothe and inspire. Our community is designed with tranquility in mind, offering lush courtyards that complement your private outdoor space.\n\nLocated in Hennepin County, The Fairways also feature convenient amenities such as in-unit laundry and free on-site parking, making daily life hassle-free. As a pet-friendly community, The Fairways welcome all family members, providing a vibrant living experience in the heart of Brooklyn Park, where comfort and convenience meet beautifully.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments, Brooklyn Park MN",
      "seo_description": "Find serene private balcony apartments in Brooklyn Park, MN, at The Fairways. Enjoy lush views paired with modern amenities for an ideal home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "studio-apartments-brooklyn-park-mn",
      "search_query": "studio apartments brooklyn park mn",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Brooklyn Park, MN",
      "h2_subtitle": "Looking for studio apartments in Brooklyn Park, MN? The Fairways offers comfortable living with a variety of amenities to suit your lifestyle.",
      "page_copy": "The Fairways in Brooklyn Park, MN, are an excellent choice for those searching for studio apartments that blend comfort with convenience. Each studio is thoughtfully designed to maximize space, providing the perfect balance between style and functionality. Our community boasts a range of modern amenities that cater to all your needs.\n\nNestled in the welcoming atmosphere of Hennepin County, The Fairways offer more than just a place to live. Residents enjoy in-unit laundry facilities, free on-site parking, and pet-friendly accommodations, all within beautiful surroundings. Spend your downtime relaxing in our lush courtyards or enjoying the view from your private balcony. Experience the charm and convenience of studio living at The Fairways in Brooklyn Park, MN.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments, Brooklyn Park MN",
      "seo_description": "Explore studio apartments in Brooklyn Park, MN at The Fairways. Enjoy modern amenities and a welcoming community perfect for simplified living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-hennepin-county",
      "search_query": "one bedroom apartments hennepin county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hennepin County",
      "h2_subtitle": "Searching for one bedroom apartments in Hennepin County? Discover spacious and comfortable living at The Fairways in Brooklyn Park.",
      "page_copy": "Discover the perfect one bedroom apartments in Hennepin County at The Fairways, located in vibrant Brooklyn Park. These thoughtfully designed apartments offer spacious living areas ideal for individuals or couples seeking comfort and style. Each unit includes modern conveniences such as in-unit laundry, ensuring a seamless lifestyle.\n\nThe Fairways enrich your living experience with additional amenities like free on-site parking and a pet-friendly environment. Step outside and enjoy our lush courtyards, or take in the fresh air from your private balcony. Nestled in a prime location, The Fairways is the perfect place to call home in Hennepin County, offering a harmonious blend of comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments, Hennepin County",
      "seo_description": "Find one bedroom apartments in Hennepin County at The Fairways in Brooklyn Park. Enjoy spacious living with modern amenities and a warm community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-55443",
      "search_query": "two bedroom apartments near 55443",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 55443",
      "h2_subtitle": "Explore two bedroom apartments near the 55443 area at The Fairways. Enjoy spacious layouts and modern amenities tailored for your needs.",
      "page_copy": "Located in the heart of Brooklyn Park, The Fairways is the perfect choice for those seeking two bedroom apartments near the 55443 area. Each apartment offers ample space and modern amenities, providing a comfortable and convenient living experience suitable for families or roommates. With in-unit laundry and private balconies, these homes are designed for your lifestyle.\n\nOur community features lush courtyards and is pet-friendly, ensuring all members of your family feel welcomed. Enjoy free on-site parking and easy access to local attractions, all while residing in a tranquil environment. The Fairways invites you to join our community where you can enjoy both spacious living and a vibrant neighborhood, just a stone's throw from the conveniences of the 55443 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 55443",
      "seo_description": "Find spacious two bedroom apartments near 55443 at The Fairways. Enjoy modern amenities in a welcoming community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-brooklyn-park-mn",
      "search_query": "three bedroom apartments brooklyn park mn",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Brooklyn Park, MN",
      "h2_subtitle": "Discover three bedroom apartments in Brooklyn Park, MN at The Fairways. Ideal for families looking for space and modern amenities.",
      "page_copy": "The Fairways proudly offers three bedroom apartments in Brooklyn Park, MN, perfect for those who need extra space without compromising on luxury. These spacious units are thoughtfully designed to accommodate families or groups, offering privacy and comfort in equal measure. Each apartment features convenient in-unit laundry and a private balcony, which enhances the living experience.\n\nThis pet-friendly community provides a tranquil environment with lush courtyards and free on-site parking. Located in a vibrant part of Hennepin County, The Fairways combines a peaceful atmosphere with easy access to local amenities and attractions. Experience the best of both worlds by making your home in one of our three bedroom apartments, where community and convenience converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments, Brooklyn Park MN",
      "seo_description": "Explore spacious three bedroom apartments in Brooklyn Park, MN at The Fairways. Ideal for families, with modern amenities and a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "apartments-near-anoka-ramsey-community-college",
      "search_query": "apartments near Anoka-Ramsey Community College Coon Rapids MN",
      "category": "School",
      "h1_title": "Apartments Near Anoka-Ramsey Community College",
      "h2_subtitle": "Looking for apartments near Anoka-Ramsey Community College in Coon Rapids, MN? Discover comfort and convenience at The Fairways.",
      "page_copy": "If you're seeking apartments near Anoka-Ramsey Community College in Coon Rapids, MN, The Fairways in Brooklyn Park offers an ideal location with easy access to the college. Our apartments provide a perfect blend of convenience, comfort, and modern amenities tailored to meet the needs of students and faculty alike. Enjoy relaxing in our spacious residences featuring in-unit laundry and private balconies.\n\nSet in a serene community with lush courtyards, The Fairways is also pet-friendly, so you can bring your furry friends. Benefit from free on-site parking and a welcoming, vibrant community environment perfect for focused studies or unwinding after a day at college. Choose The Fairways for an exceptional living experience close to Anoka-Ramsey Community College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Anoka-Ramsey College, Coon Rapids",
      "seo_description": "Discover convenient apartments near Anoka-Ramsey Community College in Coon Rapids at The Fairways. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "brooklyn-park-apartments-close-to-north-hennepin-community-college",
      "search_query": "Brooklyn Park apartments close to North Hennepin Community College",
      "category": "School",
      "h1_title": "Brooklyn Park Apartments Near North Hennepin",
      "h2_subtitle": "Discover Brooklyn Park apartments close to North Hennepin Community College. Convenience and comfort await you at The Fairways.",
      "page_copy": "The Fairways offers a prime living location for those searching for Brooklyn Park apartments close to North Hennepin Community College. Our community provides the perfect blend of convenience and superior housing, ideal for students and faculty needing accessible, comfortable accommodations.\n\nEnjoy amenities like in-unit laundry, private balconies, and free on-site parking in our pet-friendly community, designed to cater to a modern lifestyle. With lush courtyards and a warm community atmosphere, The Fairways supports both a studious environment and relaxation. Located just minutes from North Hennepin Community College, these apartments offer easy access to education, shopping, and local attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brooklyn Park Apartments Close to North Hennepin",
      "seo_description": "Find Brooklyn Park apartments near North Hennepin Community College at The Fairways. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "hennepin-county-rental-homes-near-hennepin-technical-college",
      "search_query": "Hennepin County rental homes near Hennepin Technical College",
      "category": "School",
      "h1_title": "Hennepin County Rentals Near Hennepin Tech",
      "h2_subtitle": "Explore Hennepin County rental homes near Hennepin Technical College. The Fairways offers an ideal living community.",
      "page_copy": "For those looking for Hennepin County rental homes near Hennepin Technical College, The Fairways in Brooklyn Park provides a top-notch option. Our community combines easy access to the college and the comfort of modern apartment living, making it ideal for both students and faculty seeking convenient accommodations.\n\nThe Fairways features spacious units with in-unit laundry facilities, private balconies, and lush courtyards for a serene living experience. Our pet-friendly environment and free on-site parking add to a comfortable lifestyle. Situated close to educational hubs and local amenities, The Fairways offers a perfect blend of location and lifestyle in Hennepin County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hennepin County Rentals Near Hennepin Tech",
      "seo_description": "Discover Hennepin County rental homes near Hennepin Technical College at The Fairways. Enjoy modern living with convenient college access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "apartments-near-mercy-hospital-unity-campus",
      "search_query": "apartments near mercy hospital unity campus brooklyn park",
      "category": "Hospital",
      "h1_title": "Apartments Near Mercy Hospital Unity Campus",
      "h2_subtitle": "Find convenient apartments near Mercy Hospital Unity Campus in Brooklyn Park. Enjoy modern amenities at The Fairways.",
      "page_copy": "For healthcare professionals or patients seeking apartments near Mercy Hospital Unity Campus in Brooklyn Park, The Fairways offers a perfect choice. Our community is designed to meet the needs of those requiring close proximity to the hospital while providing a serene living environment.\n\nReside in spacious units with in-unit laundry, private balconies, and enjoy the tranquility of our lush courtyards. Our pet-friendly policy ensures that your furry companions are welcome, and the convenience of free on-site parking adds to the ease of living. Experience the ideal blend of comfort and accessibility at The Fairways, just moments from Mercy Hospital Unity Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercy Hospital Unity Campus",
      "seo_description": "Explore The Fairways for modern apartments close to Mercy Hospital Unity Campus in Brooklyn Park. Ideal location with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "apartments-near-central-park-maple-grove-mn",
      "search_query": "apartments near central park maple grove MN",
      "category": "Park",
      "h1_title": "Apartments Near Central Park, Maple Grove",
      "h2_subtitle": "Discover apartments near Central Park in Maple Grove, MN. The Fairways offers an inviting community just minutes away.",
      "page_copy": "If you're looking for apartments near Central Park in Maple Grove, MN, The Fairways is an excellent option. Located just a short drive away, our community provides easy access to the vibrant activities and beautiful landscapes of Central Park.\n\nAt The Fairways, you'll enjoy in-unit laundry, private balconies, and lush courtyards that create a homely, relaxing atmosphere. Our pet-friendly environment welcomes your four-legged friends, and free on-site parking ensures convenience. Enjoy a blend of suburban tranquility and city accessibility, perfect for exploring all that Maple Grove has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Central Park, Maple Grove",
      "seo_description": "Find ideal living at The Fairways, close to Central Park in Maple Grove, MN. Enjoy modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "brooklyn-park-apartments-near-mississippi-gateway",
      "search_query": "brooklyn park apartments close to mississippi gateway regional park",
      "category": "Park",
      "h1_title": "Apartments Close to Mississippi Gateway Park",
      "h2_subtitle": "Discover Brooklyn Park apartments close to Mississippi Gateway Regional Park. Enjoy nature and modern living at The Fairways.",
      "page_copy": "If you're searching for Brooklyn Park apartments close to Mississippi Gateway Regional Park, look no further than The Fairways. Nestled in a prime location, our community provides easy access to the park's scenic trails and outdoor activities, making it an excellent choice for nature enthusiasts.\n\nResidents at The Fairways enjoy modern comforts, including in-unit laundry, private balconies, and lush courtyards that promote a peaceful living environment. Our pet-friendly policy ensures that your pets can enjoy the nearby park too, while free on-site parking adds convenience. Experience the harmony of nature and contemporary living at The Fairways, perfectly situated near Mississippi Gateway Regional Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Mississippi Gateway Park",
      "seo_description": "Experience The Fairways, featuring modern Brooklyn Park apartments near Mississippi Gateway Regional Park. Enjoy nature and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167161",
      "source": "generator",
      "page_item_url": "apartments-near-coon-rapids-dam-park",
      "search_query": "apartments near coon rapids dam regional park hennepin county",
      "category": "Park",
      "h1_title": "Apartments Near Coon Rapids Dam Park",
      "h2_subtitle": "Explore apartments near Coon Rapids Dam Regional Park in Hennepin County. Discover comfort and convenience at The Fairways.",
      "page_copy": "For those seeking apartments near Coon Rapids Dam Regional Park in Hennepin County, The Fairways offers the perfect balance of comfort and accessibility. Our community is conveniently located, allowing residents to easily explore the park's beautiful landscapes and outdoor activities.\n\nResidents at The Fairways enjoy a range of modern amenities, including in-unit laundry and private balconies that offer a personal retreat. The lush courtyards and pet-friendly environment make it ideal for both relaxation and recreation. With free on-site parking, you'll find convenience at every turn. Choose The Fairways, where nature meets modern living, just moments from Coon Rapids Dam Regional Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Coon Rapids Dam Park",
      "seo_description": "Find modern living at The Fairways, close to Coon Rapids Dam Regional Park in Hennepin County. Enjoy easy access to nature and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309088641"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7632443529"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PHTJTMGF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "b5a4c490-d4a1-4bf4-99d1-21e2f1d6c69c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/93580168-f3ef-46be-984a-7e2cb1007fc5/app.js?property=93580168-f3ef-46be-984a-7e2cb1007fc5&propertyName=The+Fairways+at+Edinburgh&channelUuid=c248e530-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": "Fairways_at_Edinburgh_hCW66NzXC7ZrE8qTXIDp"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlFJL01QSFd4M09kckYyNmJpWkhJc3c9PSIsInZhbHVlIjoiMXFwT2tQKzdLbStPd0NmSEM3TENtUT09IiwibWFjIjoiZDY0MTFhY2NlMzlkOTc0ZWUzZDJjMTRlZjQ1MjdiYmQ2MmIyNmY5MWRlZTZjNDUyYjkwYTI0YTYwMTQxZTdlNiJ9"
    }
  ],
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309088641",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7632443529",
  "custom_google_gtm_id": "GTM-PHTJTMGF",
  "custom_rollout_phase": "Phase 2",
  "custom_rentgrata_token": "b5a4c490-d4a1-4bf4-99d1-21e2f1d6c69c",
  "custom_vibesites_theme": "Avenue",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/93580168-f3ef-46be-984a-7e2cb1007fc5/app.js?property=93580168-f3ef-46be-984a-7e2cb1007fc5&propertyName=The+Fairways+at+Edinburgh&channelUuid=c248e530-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_cort_lead_form_id": "Fairways_at_Edinburgh_hCW66NzXC7ZrE8qTXIDp",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlFJL01QSFd4M09kckYyNmJpWkhJc3c9PSIsInZhbHVlIjoiMXFwT2tQKzdLbStPd0NmSEM3TENtUT09IiwibWFjIjoiZDY0MTFhY2NlMzlkOTc0ZWUzZDJjMTRlZjQ1MjdiYmQ2MmIyNmY5MWRlZTZjNDUyYjkwYTI0YTYwMTQxZTdlNiJ9",
  "custom_audioeye_site_id": "56f03725-c0bd-4b92-a530-ad435f818b3e",
  "custom_audioeye_site_hash": "2f495e7e387acfd2e00795ab7493551d"
};

export const generatedAt = '2026-09-15T18:32:55.209Z';
